import Employee from '../Employee';
import Kindergarten from '../Kindergarten';

export default class VacationRequest {
    static fromData(data) {
        if (!data) {
            return;
        }

        const vacationRequest = new VacationRequest();
        vacationRequest.id = data.id;
        vacationRequest.kindergarten = Kindergarten.fromData(data.kindergarten.data);
        vacationRequest.employee = Employee.fromData(data.employee.data);
        vacationRequest.labelling = data.labelling;
        vacationRequest.createdAt = data.createdAt;
        vacationRequest.start = data.start;
        vacationRequest.end = data.end;
        vacationRequest.days = data.days;
        vacationRequest.updatedByAdmin = data.updatedByAdmin;
        vacationRequest.approved = data.approved;

        return vacationRequest;
    }
}
